module.exports = __webpack_public_path__ + "img/green_066.8894eedf.png";